import { useState, useCallback } from 'react';

export default initialValue => {
  const [flag, setFlag] = useState(initialValue);

  const setTrue = useCallback(() => setFlag(true), []);
  const setFalse = useCallback(() => setFlag(false), []);

  return [flag, setTrue, setFalse];
};
